import { render, staticRenderFns } from "./DiseaseInfo.vue?vue&type=template&id=afa9124c&scoped=true&"
import script from "./DiseaseInfo.vue?vue&type=script&lang=js&"
export * from "./DiseaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa9124c",
  null
  
)

export default component.exports